// Package Imports
import React from 'react';

// Project Imports
import { Images } from 'core/common/imagePath';

type LoadingType = {
  componentLoading?: boolean;
};
const Loading = ({ componentLoading }: LoadingType) => (
  <div
    className={`flex items-center justify-center ${
      componentLoading ? 'h-full' : 'h-screen'
    } `}
  >
    <img width="100px" src={Images.loaderGif} />
  </div>
);

export default Loading;
